"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var LayoutTabModel = /** @class */ (function () {
    function LayoutTabModel(tabId, tabLayout, title, properties) {
        this.title = title;
        this.tabId = tabId;
        this.tabLayout = tabLayout;
        this.properties = properties;
    }
    LayoutTabModel.prototype.titleFromMap = function (titleMap) {
        var keys = Object.keys(titleMap);
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        keys.forEach(function (key) {
            multilingualStringBuilder.withValueForLanguage(Number(key), titleMap[key]);
        });
        this.title = multilingualStringBuilder.build();
    };
    return LayoutTabModel;
}());
exports.LayoutTabModel = LayoutTabModel;
//# sourceMappingURL=layout.tab.model.js.map